import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  className?: string;
  width?: number;
}

export const Box = ({ children, className, width }: Props) => {
  let style: React.CSSProperties | undefined;

  if (width) {
    style = {
      width,
    };
  }

  return (
    <div
      style={style}
      className={`min-h-12 min-w-12 rounded-xl border-2 border-deep-gray-700 bg-deep-gray-800 p-1 text-deep-gray-300 shadow-3xl ${
        className || ''
      }`}
    >
      {children}
    </div>
  );
};